import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        isLoading: '<',
        isPreviewLoading: '<',
        hasContent: '<',
        onClose: '&',
        onSave: '&',
        onToggleSettings: '&',
        onPreview: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/header/index.js